import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Form, Formik } from "formik";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import * as yup from "yup";

import { hooks } from "../hooks";
import { components } from "../components";
import AuthLayout from "../services/auth/jwt/withAuth";
import { showErrorToast, showSuccessToast } from "../components/apps/AppError";
import { UPDATE_LOGIN_PASSWORD } from "../graphql/mutations/profile";
import { AppSubmitButton, AppTextField } from "../components/apps";
import { useQueryProfile } from "../graphql/apollo/useQuery";

export const UpdatePasswordScreen: React.FC = () => {
  const { t } = useTranslation();
  const navigate = hooks.useNavigate();
  const { myProfile, refetch } = useQueryProfile();
  const havePassword = myProfile?.withdrawPassword;
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };

    scrollToTop();
  }, [pathname]);

  const validationSchema = yup.object({
    oldPassword: yup.string(),
    password: yup.string(),
    passwordConfirm: yup.string(),
  });

  const [updatePassword, { loading }] = useMutation(UPDATE_LOGIN_PASSWORD, {
    onCompleted: (data) => {
      if (data.updatePassword) {
        showSuccessToast();
        navigate(-1);
        refetch();
      }
    },
    onError: (err) => {
      showErrorToast(err.message);
    },
  });

  const handleSubmit = (data: any) => {
    updatePassword({
      variables: {
        input: {
          oldPassword: data.oldPassword,
          password: data.password,
          passwordConfirm: data.passwordConfirm,
        },
      },
    });
  };

  return (
    <AuthLayout>
      <components.Header goBack title={t("loginPassword")} />
      <main
        className="container"
        style={{ paddingTop: "14%", paddingBottom: 20 }}
      >
        <div
          className="custom-block"
          style={{ padding: 20, marginTop: 20, marginBottom: 10 }}
        >
          <Formik
            validateOnChange
            initialValues={{ amount: 0 }}
            onSubmit={(data: any) => handleSubmit(data)}
            validationSchema={validationSchema}
          >
            {() => (
              <Form noValidate autoComplete="off">
                {havePassword && (
                  <AppTextField
                    placeholder={t("oldPassword")}
                    name="oldPassword"
                    label={t("oldPassword")}
                  />
                )}
                <AppTextField
                  placeholder={t("newPassword")}
                  name="password"
                  label={t("newPassword")}
                />
                <AppTextField
                  placeholder={t("confirmNewPassword")}
                  name="passwordConfirm"
                  label={t("confirmNewPassword")}
                />
                <AppSubmitButton
                  label={t("confirm")}
                  disabled={false}
                  loading={loading}
                />
              </Form>
            )}
          </Formik>
        </div>
      </main>
    </AuthLayout>
  );
};
